import {Field} from 'formik';
import {Container} from "@mantine/core";
import {
    FormikDateTimePicker,
    FormikNumberInput,
    FormikRadioGroup,
    FormikSelect,
    FormikTextarea,
    PlatformFieldset
} from "@flexinet/ui-components";
import {CustomersAutocomplete} from "../../customers/inputs/CustomersAutocomplete.tsx";
import {MetersAutocomplete} from "../../meters/inputs/MetersAutocomplete.tsx";
import {useChannelOptions} from "../../billing-providers/hooks/useChannelOptions.ts";

export const FormComponent = () => {

    // FNP-616: channel options are catalog-driven (the ENABLED BillingProvider keys), not a
    // hardcoded enum. Onboarding a provider in the catalog makes it selectable here with no
    // code change.
    const {options: channelOptions, loading: channelsLoading} = useChannelOptions();

    return (
        <Container>
            <PlatformFieldset legend={'Meter Assignment'}>
                <Field
                    name='customerId'
                    label='Customer'
                    description='Please select the customer'
                    component={CustomersAutocomplete}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='meterId'
                    label='Meter'
                    description='Please select the meter'
                    component={MetersAutocomplete}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='channel'
                    label='Channel'
                    description='The billing channel this assignment reports usage to (an enabled billing provider)'
                    component={FormikSelect}
                    data={channelOptions}
                    disabled={channelsLoading}
                    placeholder={channelsLoading ? 'Loading channels…' : 'Select a channel'}
                    withAsterisk
                    my={'xl'}
                />
            </PlatformFieldset>

            <PlatformFieldset legend={'Channel Identifiers'}>
                <Field
                    name='channelIdentifiers'
                    label='Channel Identifiers (JSON)'
                    description='JSON object — { "subscriptionItemId": "..." } for Stripe, or { "customerIdentifier": "...", "dimension": "..." } for AWS Marketplace'
                    component={FormikTextarea}
                    minRows={4}
                    autosize
                    withAsterisk
                    my={'xl'}
                />
            </PlatformFieldset>

            <PlatformFieldset legend={'Quantities'}>
                <Field
                    name='freeTierQuantity'
                    label='Free Tier Quantity'
                    description='Usage granted before metered charges begin (optional)'
                    component={FormikNumberInput}
                    my={'xl'}
                />

                {/* FNP-835: the Committed Quantity field was removed. It was editable and
                    displayed but read by NO billing logic — an admin could type a number
                    into a money-path field, see it saved, and it affected nothing. A real
                    Commitment is bilateral (both sides, a term, a divergence rule) and is
                    trigger-gated on FNP-842. Do not re-add a bare quantity input. */}
            </PlatformFieldset>

            <PlatformFieldset legend={'Effective Window'}>
                <Field
                    name='effectiveFrom'
                    label='Effective From'
                    description='When this assignment starts applying'
                    component={FormikDateTimePicker}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='effectiveTo'
                    label='Effective To'
                    description='When this assignment stops applying (optional)'
                    component={FormikDateTimePicker}
                    my={'xl'}
                />
            </PlatformFieldset>

            <PlatformFieldset legend={'Status'}>
                <Field
                    name='status'
                    label='Status'
                    description='Please select the status'
                    component={FormikRadioGroup}
                    data={[{
                        value: 'ACTIVE',
                        label: 'Active',
                    }, {
                        value: 'PAUSED',
                        label: 'Paused',
                    }, {
                        value: 'CANCELED',
                        label: 'Canceled',
                    }]}
                    withAsterisk
                    my={'xl'}
                />
            </PlatformFieldset>

        </Container>
    );
};
